export const transparent = {
    r: 0,
    g: 0,
    b: 0,
    a: 0,
};
export const parseColorString = (color) => {
    if (color === 'transparent') {
        return transparent;
    }
    let r, g, b, a;
    const rgbaStr = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
    if (rgbaStr) {
        r = Number(rgbaStr[1]);
        g = Number(rgbaStr[2]);
        b = Number(rgbaStr[3]);
        a = Number(rgbaStr[4] || '1');
    }
    else {
        if (!color.match(/^#?[A-Fa-f0-9]{3}([A-Fa-f0-9]{2,3})?$/)) {
            throw new Error(`Unable to parse color string: "${color}"`);
        }
        let hex = color;
        if (hex.startsWith('#')) {
            hex = hex.slice(1);
        }
        if (hex.length < 5) {
            hex = hex.replace(/./g, '$&$&');
        }
        const rgbNum = Number('0x' + hex);
        r = rgbNum >> 16;
        g = (rgbNum >> 8) & 255;
        b = rgbNum & 255;
        a = 1;
    }
    return { r, g, b, a };
};
export const toHSP = ({ r, g, b }) => 
// HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
export function getModeByBackgroundColor(
// exclude `TonieColors` as valid "string"
color) {
    if (!color)
        return 'light';
    const rgba = parseColorString(color);
    if (rgba.a < 1) {
        return 'light';
    }
    const hsp = toHSP(rgba);
    if (hsp > 160) {
        return 'light';
    }
    else {
        return 'dark';
    }
}
